import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
} from "@mui/material";

//CUSTOM IMPORT
import Navbar from "../../../../Navbar";
import TitleUploaded from "../../../../TitleUploaded";
import FormPeqProveedor from "./FormPeqProveedor"


function AddPeqProveedor() {
  const navigate = useNavigate();

  const handleCloseAddProveedor = (idProveedor) => {
    navigate("/listado_proveedores");
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", bgcolor: "#fafafa" }}>
        <Navbar />
        <Box px={2}>
          <TitleUploaded title="Pequeños Proveedores" handleClose={handleCloseAddProveedor} />
        </Box>
        <FormPeqProveedor 
          edicion={false} 
          titulo={"Nuevo Pequeño Proveedor"} 
          textBtn="Guardar Proveedor" 
          handleCloseAddProveedor={handleCloseAddProveedor} 
        />
      </Box>
    </>
  );
}

export default AddPeqProveedor;
